module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/kv@2x-fb5bb5c1dd293f8f0c8a1a3bc4c14a03.png";